export async function fetchAutocompleteData(
  addressQuery: string,
  options: { filter?: { street: boolean } } = {}
) {
  const runtimeConfig = useRuntimeConfig()
  const data = await $fetch<AutocompleteData[]>('/nominatim', {
    baseURL: runtimeConfig.public.dbOsmBaseURL,
    query: {
      q: addressQuery,
      format: 'geocodejson',
      key: runtimeConfig.public.dbOsmApiKey,
      countrycodes: 'de',
      addressdetails: 1,
      layer: 'address',
    },
    onResponse({ response }) {
      response._data = response._data.features
        .filter(
          (feature: DBOSMFeature) =>
            feature.geometry.coordinates &&
            feature.properties.geocoding.city &&
            feature.properties.geocoding.postcode
        )
        .filter((feature: DBOSMFeature) =>
          options.filter?.street ? feature.properties.geocoding.street : true
        )
        .map((feature: DBOSMFeature) => {
          const street = feature.properties.geocoding.street || ''
          const houseNumber = feature.properties.geocoding.housenumber || ''
          const name = feature.properties.geocoding.name || ''
          const postcode = feature.properties.geocoding.postcode || ''
          const city = feature.properties.geocoding.city || ''
          const address = [street, houseNumber, name, postcode, city]
            .filter(Boolean)
            .join(' ')

          return {
            address: address,
            id: feature.properties.geocoding.osm_id,
            longitude: feature.geometry.coordinates[0],
            latitude: feature.geometry.coordinates[1],
          }
        })
        .filter(
          (item1: AutocompleteData, i: number, items: AutocompleteData[]) =>
            items.findIndex((item2) => item2.address === item1.address) === i
        )
      return response._data
    },
  })

  return data
}
